import React, { Component } from 'react'
import { Modal, Input, message, Select, Button } from 'antd'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { observer, inject } from 'mobx-react'
import { API, CreateOrUpdateTransfer } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../../../utilities/helpers'
import { Track } from '../../../../../Track'
import { browserHistory } from 'react-router'
import { Routes } from '../../../../../constants/Routes'

interface Props {
  onClose: () => void
  visible: boolean
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class CreateTransferModal extends Component<Props & InjectedProps> {
  constructor(props: Props) {
    super(props)
  }

  transfer = new CreateOrUpdateTransfer()

  save = async () => {
    const companyId = this.props.currentCompanyStore!.company!.id

    try {
      const createdTransfer = await API.createTransfer(companyId, this.transfer)

      Track.track('dashboard:transfers_created', createdTransfer)
      browserHistory.push(Routes.EDIT_INVENTORY_BULK_TRANSFER(companyId, createdTransfer.id))
    } catch (error) {
      message.error(parseErrorMsg(error) || 'An error occurred while creating an audit')
    }
  }

  get isSaveDisabled(): boolean {
    return !this.transfer.title || !this.transfer.fromLocationId || !this.transfer.toLocationId
  }

  setTransferLocationIds = (toLocationId?: number) => {
    this.transfer.toLocationId = toLocationId

    if (this.transfer.fromLocationId === toLocationId) {
      this.transfer.fromLocationId = undefined
    }
  }

  render() {
    const locations = this.props.currentCompanyStore!.locations || []

    return (
      <Modal
        title='Create a transfer'
        visible={this.props.visible}
        onCancel={this.props.onClose}
        footer={[
          <Button key='cancel' onClick={this.props.onClose}>
            Cancel
          </Button>,
          <Button key='save' type='primary' disabled={this.isSaveDisabled} onClick={this.save}>
            Save
          </Button>,
        ]}
      >
        <div>
          <div className='mb-4'>
            <label>
              Title <span className='text-danger'>*</span>
            </label>
            <Input
              value={this.transfer.title}
              onChange={(e) => (this.transfer.title = e.target.value)}
            />
          </div>

          <div className='mb-4'>
            <label className='d-block'>
              Source <span className='text-danger'>*</span>
            </label>
            <Select<number | undefined>
              value={this.transfer.fromLocationId}
              placeholder='Select a source location'
              onChange={(fromLocationId) => (this.transfer.fromLocationId = fromLocationId)}
              className='d-block'
            >
              {locations.map((location) => {
                return (
                  <Select.Option
                    key={location.id}
                    value={location.id}
                    disabled={location.id === this.transfer.toLocationId}
                  >
                    {location.name}
                  </Select.Option>
                )
              })}
            </Select>
          </div>

          <div className='mb-4'>
            <label className='d-block'>
              Destination <span className='text-danger'>*</span>
            </label>
            <Select<number | undefined>
              value={this.transfer.toLocationId}
              placeholder='Select a destination location'
              onChange={this.setTransferLocationIds}
              className='d-block'
            >
              {locations.map((location) => {
                return (
                  <Select.Option key={location.id} value={location.id}>
                    {location.name}
                  </Select.Option>
                )
              })}
            </Select>
          </div>
        </div>
      </Modal>
    )
  }
}
